import { dummyData } from '../dummy';
import { Divider } from '../Divider';

export const GoodsDetail = () => {
    return (
        <>
            <section aria-labelledby="product-image-heading">
                <figure className="w-full h-full flex flex-col items-center justify-center">
                    <img src={dummyData.product_image} alt="product_image" />
                    <figcaption id="product-image-heading" className="sr-only">
                        {dummyData.brand_name} {dummyData.product_name}
                    </figcaption>
                </figure>
            </section>

            <Divider />

            <section
                aria-labelledby="product-info-heading"
                className="w-full h-full flex flex-col items-start justify-center py-5"
            >
                <h2 id="product-info-heading" className="sr-only">
                    제품 정보
                </h2>
                <dl className="w-full h-full flex flex-col gap-2">
                    <div className="w-full h-full flex justify-between">
                        <dt className="text-lg color-black/60">브랜드명</dt>
                        <dd>{dummyData.brand_name}</dd>
                    </div>

                    <div className="w-full h-full flex justify-between">
                        <dt className="text-xl color-black/60">제품명</dt>
                        <dd>{dummyData.product_name}</dd>
                    </div>

                    <div className="w-full h-full flex justify-between">
                        <dt className="text-xl font-bold">색상</dt>
                        <dd>{dummyData.color}</dd>
                    </div>
                </dl>
            </section>

            <Divider />

            <section
                aria-labelledby="beauty-info-heading"
                className="w-full h-full flex flex-col items-start justify-center py-5"
            >
                <h2 id="beauty-info-heading" className="text-xl color-black/60">
                    뷰티 정보
                </h2>
                <dl className="w-full h-full flex flex-col gap-2">
                    <div className="w-full h-full flex justify-between">
                        <dt>퍼스널 컬러</dt>
                        <dd>{dummyData.beauty.personalColor}</dd>
                    </div>

                    <div className="w-full h-full flex justify-between">
                        <dt className="color-black/60">퍼스널 컬러 세부톤</dt>
                        <dd>{dummyData.beauty.personalDetailColor}</dd>
                    </div>
                </dl>
            </section>
        </>
    );
};
